"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    numberFieldEmphasisVariants: ()=>numberFieldEmphasisVariants,
    inputVariants: ()=>inputVariants,
    numberFieldEmphases: ()=>numberFieldEmphases,
    numberFieldIconButtonVariants: ()=>numberFieldIconButtonVariants,
    numberFieldVariants: ()=>numberFieldVariants,
    inputEmphasisCompoundVariants: ()=>inputEmphasisCompoundVariants,
    numberFieldSizeVariants: ()=>numberFieldSizeVariants,
    numberFieldsSizes: ()=>numberFieldsSizes,
    numberFieldIconButtonTypes: ()=>numberFieldIconButtonTypes,
    inputTypes: ()=>inputTypes
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const numberFieldIconButtonVariants = {
    primary: {
        add: 'primary',
        remove: 'secondary'
    },
    secondary: {
        add: 'secondary',
        remove: 'secondary'
    }
};
const numberFieldIconButtonTypes = Object.keys(numberFieldIconButtonVariants);
const inputVariants = {
    transparent: {
        numericInput: 'border-none'
    },
    box: {
        numericInput: 'border'
    }
};
const inputTypes = Object.keys(inputVariants);
const numberFieldSizeVariants = {
    sm: {
        group: 'w-32',
        ctaButton: 'w-32'
    },
    md: {
        group: 'w-36',
        ctaButton: 'w-36'
    },
    lg: {
        group: 'w-40',
        ctaButton: 'w-40'
    },
    xl: {
        group: 'w-48',
        ctaButton: 'w-48'
    }
};
const numberFieldsSizes = Object.keys(numberFieldSizeVariants);
const numberFieldEmphasisVariants = {
    regular: {
        numericInput: [
            'text-primary-13 disabled:text-primary-6',
            'bg-primary-1 border-primary-6',
            'focus-visible:inset-ring-actionPrimary-12',
            'disabled:bg-primary-2 disabled:border-primary-2 disabled:hover:bg-primary-2'
        ]
    },
    medium: {
        numericInput: [
            'text-primary-13, disabled:text-primary-6',
            'bg-primary-1 border-primary-6',
            'focus-visible:inset-ring-actionPrimary-12',
            'disabled:bg-primary-1/60 disabled:border-primary-5 disabled:hover:bg-primary-1/60'
        ]
    },
    bold: {
        numericInput: [
            'text-primary-1 disabled:text-primary-1/40',
            'bg-primary-1/20 border-primary-1/40',
            'focus-visible:inset-ring-primary-1',
            'disabled:bg-primary-1/20 disabled:border-primary-1/20 disabled:hover:bg-primary-1/20'
        ]
    }
};
const numberFieldEmphases = Object.keys(numberFieldEmphasisVariants);
const inputEmphasisCompoundVariants = [
    {
        inputType: 'transparent',
        emphasis: 'regular',
        class: {
            numericInput: [
                'bg-transparent border-none',
                'disabled:bg-transparent disabled:border-none, disabled:hover:bg-transparent disabled:hover:border-none'
            ]
        }
    },
    {
        inputType: 'transparent',
        emphasis: 'medium',
        class: {
            numericInput: [
                'bg-transparent border-none',
                'disabled:bg-transparent disabled:border-none, disabled:hover:bg-transparent disabled:hover:border-none'
            ]
        }
    },
    {
        inputType: 'transparent',
        emphasis: 'bold',
        class: {
            numericInput: [
                'bg-transparent border-none',
                'disabled:bg-transparent disabled:border-none, disabled:hover:bg-transparent disabled:hover:border-none'
            ]
        }
    }
];
const numberFieldVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        root: '',
        group: 'flex items-center justify-center gap-2 rounded-md',
        numericInput: [
            'hover:shadow-input-hover flex h-8 min-w-0 flex-1 rounded-lg py-1 text-center tabular-nums disabled:hover:shadow-none',
            'focus-within:z-1 focus-visible:inset-ring-2 focus-visible:inset-ring-offset-2 focus-visible:border-transparent focus-visible:shadow-none focus-visible:outline-none'
        ],
        ctaButton: '',
        icon: ''
    },
    variants: {
        emphasis: numberFieldEmphasisVariants,
        inputType: inputVariants,
        size: numberFieldSizeVariants
    },
    compoundVariants: [
        ...inputEmphasisCompoundVariants
    ],
    defaultVariants: {
        emphasis: 'regular',
        inputType: 'box',
        size: 'sm'
    }
});
exports.inputEmphasisCompoundVariants = __webpack_exports__.inputEmphasisCompoundVariants;
exports.inputTypes = __webpack_exports__.inputTypes;
exports.inputVariants = __webpack_exports__.inputVariants;
exports.numberFieldEmphases = __webpack_exports__.numberFieldEmphases;
exports.numberFieldEmphasisVariants = __webpack_exports__.numberFieldEmphasisVariants;
exports.numberFieldIconButtonTypes = __webpack_exports__.numberFieldIconButtonTypes;
exports.numberFieldIconButtonVariants = __webpack_exports__.numberFieldIconButtonVariants;
exports.numberFieldSizeVariants = __webpack_exports__.numberFieldSizeVariants;
exports.numberFieldVariants = __webpack_exports__.numberFieldVariants;
exports.numberFieldsSizes = __webpack_exports__.numberFieldsSizes;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "inputEmphasisCompoundVariants",
    "inputTypes",
    "inputVariants",
    "numberFieldEmphases",
    "numberFieldEmphasisVariants",
    "numberFieldIconButtonTypes",
    "numberFieldIconButtonVariants",
    "numberFieldSizeVariants",
    "numberFieldVariants",
    "numberFieldsSizes"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
